module.exports = __webpack_public_path__ + "img/reference-zahnarzt-bargon.053a68c7.webp";